import React from 'react';
import store from '../store';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Content from '../components/Content';

import createHistory from 'history/createBrowserHistory';
import { Redirect } from 'react-router-dom';
import * as STATIC from '../config/static';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import {NotificationContainer} from 'react-notifications';
import _ from 'lodash';
import moment from 'moment';
import { FIREBASE } from "../config/firebase";
import firebase from "firebase/app";
import "firebase/firestore";
import Modal from 'react-responsive-modal';


if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE);
}

const firestore = firebase.firestore();
const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 0,
    position: 'relative',
    display: 'block',

    width: '100%',
    backgroundImage:"url('assets/images/giraffes.jpg')","display":"inline","float":"left","width":"100%","backgroundPosition":"center center","backgroundAttachment":"fixed","WebkitBackgroundSize":"cover","backgroundSize":"cover"
  },
  overlay:{
    flexGrow: 1,
    zIndex: 1,

    height: '100%',
    width: '100%',
    "backgroundColor":"#EE3268","opacity": "0.94","background":"linear-gradient(to right, #64b3f4, #EE3268)"
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 2,
    paddingTop: theme.spacing.unit * 4,
    minWidth: 0,
    marginRight: 'auto',
    marginLeft: 'auto',
    maxWidth: 780
  },
  contentdata: {
    height: '100%',
    width: '100%'
  },
  toolbar: theme.mixins.toolbar,
});
const adminPath = ['/sbadmin','/sbadmin/login','/sbadmin/course','/sbadmin/guest','/sbadmin/video','/sbadmin/challenges'];
class ClippedDrawer extends React.Component {
  constructor() {
    super();
    this.state = {showUpdate:false};

  }

  async componentDidMount()
  {
    store.subscribe(()=>{

      let UP_VER = store.getState().UP_VER;
      //console.log(UP_VER);
      if(UP_VER!=true)
      {
        this.setState({showUpdate:true});
      }
      else {
        this.setState({});
      }
    });
    this.loadData();
    this.loadDataCourse();
    this.loadInners();
    this.loadSoundSetting();
    this.loadLangSetting();
    this.loadSetting();
      //console.log(window.location.pathname);

    //  this.setState({loading:false})
  }
  async loadInners(){
    let INNERS = localStorage.getItem('INNERS');
    if(INNERS)
    {
      INNERS = JSON.parse(INNERS);

    }
    else {
      INNERS = {};
    }
    store.dispatch({ type: 'INNERS', INNERS });
  }
  async loadSoundSetting(){
    let SOUND = localStorage.getItem('SOUND');
    if(SOUND)
    {
      SOUND = SOUND;
    }
    else {
      SOUND = 1;
      localStorage.setItem('SOUND',1);
    }

    store.dispatch({ type: 'SOUND', SOUND });
  }
  async loadLangSetting(){
    let LANG = localStorage.getItem('LANG');
    if(LANG)
    {
      LANG = LANG;
    }
    else {
      LANG = 'en';
      localStorage.setItem('LANG',LANG);
    }
    this.props.i18n.changeLanguage(LANG);

    store.dispatch({ type: 'LANG', LANG });
  }
  async loadSetting(){
    let BG = localStorage.getItem('BG');
    if(BG)
    {
      store.dispatch({ type: 'BG', BG });
    }
    let doc = await firebase.firestore().collection('settings').doc("background").get();

    if(doc.exists)
    {
      let setting = doc.data();
      setting.id = doc.id;
      store.dispatch({ type: 'BG', BG:setting.pc });
      localStorage.setItem('BG', setting.pc);
    }

  }
  async loadDataCourse(){
      let data = await firebase.firestore().collection('data_courses').get();
      let DATA_COURSES = [];
      if(data.size){
        data.forEach(doc=>{
          let item = doc.data();
          DATA_COURSES.push(item);
        })
        store.dispatch({ type: 'DATA_COURSES', DATA_COURSES });
      }

  }
  async loadData(){
    let pathName = window.location.pathname.toLowerCase();

    if(adminPath.findIndex(a=>a==pathName)>-1)
    {
      let ADMINACCOUNT = localStorage.getItem('ADMINACCOUNT');
      if(ADMINACCOUNT)
      {
        ADMINACCOUNT = JSON.parse(ADMINACCOUNT);
        store.dispatch({ type: 'ADMINACCOUNT', ADMINACCOUNT });
      }

    }
    else {
      let ACCOUNT = localStorage.getItem('ACCOUNT');
      if(ACCOUNT)
      {
        ACCOUNT = JSON.parse(ACCOUNT);
        store.dispatch({ type: 'ACCOUNT', ACCOUNT});


          setTimeout(()=>{
            this.checkAccountToken(ACCOUNT);
          },2000)

      }
      let ACCOUNTCOMP = localStorage.getItem('ACCOUNTCOMP');
      if(ACCOUNTCOMP)
      {
        ACCOUNTCOMP = JSON.parse(ACCOUNTCOMP);
        store.dispatch({ type: 'ACCOUNTCOMP', ACCOUNTCOMP});
      }
      let ACCOUNTCOMP_TOKEN = localStorage.getItem('ACCOUNTCOMP_TOKEN');
      if(ACCOUNTCOMP_TOKEN)
      {
        ACCOUNTCOMP_TOKEN = JSON.parse(ACCOUNTCOMP_TOKEN);
        store.dispatch({ type: 'ACCOUNTCOMP_TOKEN', ACCOUNTCOMP_TOKEN});
      }



    }
    //store.dispatch({ type: 'BG', BG:"assets/comp/bg_wait.png" });
    store.dispatch({ type: 'LOADING', LOADING:false });
    //this.setState({loading:false});
  }
  async checkAccountToken(ACCOUNT){
      let TOKEN = localStorage.getItem('TOKEN');
      if(TOKEN)
      {
        TOKEN = JSON.parse(TOKEN);
        if(TOKEN.id)
        {
          let tDoc = await firestore.collection("tokens").doc(TOKEN.id).get();
          if(tDoc.exists)
          {
            let tData = tDoc.data();
            //console.log(tData.id_user,TOKEN.id_user,ACCOUNT.id);
            if(tData.id_user == TOKEN.id_user&&TOKEN.id_user==ACCOUNT.id&&moment(tData.expired).isAfter(moment()))
            {

              //console.log('Token Valid');
            }
            else
            {
              firestore.collection("tokens").doc(TOKEN.id).delete();
              localStorage.removeItem('TOKEN');
              localStorage.removeItem('ACCOUNT');
              store.dispatch({ type: 'ACCOUNT', ACCOUNT:false });
            }
          }
          else {
            localStorage.removeItem('TOKEN');
            localStorage.removeItem('ACCOUNT');
            store.dispatch({ type: 'ACCOUNT', ACCOUNT:false });
          }
        }
        else {
          localStorage.removeItem('TOKEN');
          localStorage.removeItem('ACCOUNT');
          store.dispatch({ type: 'ACCOUNT', ACCOUNT:false });
        }

      }
      else {
        localStorage.removeItem('ACCOUNT');
        store.dispatch({ type: 'ACCOUNT', ACCOUNT:false });
      }

  }

  render() {
    const { classes,t } = this.props;
let UP_VER = store.getState().UP_VER;
let fLarge = STATIC.DWIDTH * 0.06;

let fNormal = STATIC.DWIDTH * 0.03;
let fSmall = STATIC.DWIDTH * 0.02;
  //  const ACCOUNT = store.getState().ACCOUNT;
  if(store.getState().LOADING)
  {
    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
      <div className={classes.middle} >
              <center>
              <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>
                <div>
                  <img src="assets/web/logo_color.png" style={{width: "100%",height:"auto"}} />
                  </div>
                  <div>
                  <CircularProgress color="secondary"/>
                  </div>

              </div>

              </center>
          </div>
          <div style={{position:'fixed',right:0,bottom:0,fontSize:8,zIndex:1}}>v{STATIC.version}</div>
      </div>
    );
  }
    return (
      <div>


         <Content />
           <Modal styles={{overlay:{padding:0}, modal: { background: 'none',textAlign:'center' } }} onClose={()=>{}} showCloseIcon={false} focusTrapped={false} open={this.state.showUpdate} center>
             <div style={{ width: "100%", backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH), padding: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) }}>
               <div style={{ display: 'flex',flexDirection:'column' }}>

                   <div style={{textAlign: 'center', fontSize: fLarge, marginTop: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH)}}>{t('common.new_update')}</div>
                   <Grid container justify='center'>
                     <Grid item xs={12} style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) + 'px', marginBottom: 10 }}>

                        <div style={{textAlign: 'center', fontSize: fNormal}}>{t('common.new_version_available',{version:UP_VER})}</div>
                     </Grid>
                     <Grid item xs={12} style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) + 'px', marginBottom: 10 }}>

                        <div style={{textAlign: 'center', fontSize: fSmall}}>{t('common.new_version_des')}</div>
                     </Grid>

                   </Grid>
                   </div>
                 </div>
               </Modal>


        <NotificationContainer/>
        <div style={{position:'fixed',fontSize:10,right:5,bottom:5,fontSize:8,zIndex:1,backgroundColor:'rgba(255, 255, 255, 0.5)'}}>v{STATIC.version}</div>
      </div>
    );
  }
}

ClippedDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(ClippedDrawer));
